export default __webpack_public_path__ + "static/media/img_baseBunnyCrochetRattle_rose.8000fdf0.jpg";